module.exports = __webpack_public_path__ + "static/media/twitter.c9b500a0.svg";